// fetch
import { post, getWithToken, postWithToken } from './fetch.js';

// urls
import urls from './_services.json';

// util
import { getUrl } from './util.js';

/**
 * sendLoginPhoneCode
 * @param {*} phone
 */
export async function sendLoginPhoneCode(phone) {
  const url = getUrl(urls.sendLoginPhoneCode);
  return await post(url, { phone });
}

/**
 * loginByPhoneCode
 * @param {*} phone
 * @param {*} code
 * @returns
 */
export async function loginByPhoneCode(phone, code) {
  const url = getUrl(urls.loginByPhoneCode);
  return await post(url, { phone, code });
}

/**
 * 更新用户信息
 * @param {*} nickName
 * @param {*} avatar
 * @returns
 */
export async function updateUserInfo(data) {
  const url = getUrl(urls.updateUserInfo);
  return await postWithToken(url, data);
}

/**
 * 用户留资结果
 * invitationResult
 * @returns
 */
export async function invitationResult() {
  const url = getUrl(urls.invitationResult);
  return await getWithToken(url);
}

/**
 * 国内shakker登录回调
 * @returns
 */
export async function loginShakkerCallBack() {
  return await getWithToken(getUrl(urls.loginShakkerCallBack));
}

/* loginToGoogle
 * @param {*}
 */
export async function loginToGoogle(params = {}) {
  const url = getUrl(urls.loginToGoogle);
  return await getWithToken(url, params);
}

/**
 * loginToDiscord
 * @param {*}
 */
export async function loginToDiscord(params = {}) {
  const url = getUrl(urls.loginToDiscord);
  return await getWithToken(url, params);
}

/**
 * sendEmail
 * @param {*} email
 */
export async function sendEmail(data) {
  const url = getUrl(urls.sendEmail);
  return await postWithToken(url, data);
}
